<template>
  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>

  <div class="cell small-12">
    <h1>Pension Provider</h1>
    <p>Provide the name of the provider for your auto enrolment pension.</p>
    </div>
    <div class="cell small-8">
      <form class="fieldset" @submit.prevent>
        <label>Pension Provider</label>
        <AutoSuggest
            v-model="formData.pensionProviderName"
            :suggestions="providers"
            name="pensionProviderName"
            regexPattern="[A-Za-z0-9' ]*" />

      </form>
    </div>
  


</template>


<script setup>

import { ref, onMounted } from 'vue'
import AutoSuggest from '@/components/controls/AutoSuggest.vue'

const error = ref([]);

const props = defineProps({
  formData: Object
})

const providers = [
  "NEST",
  "People's Pension",
  "Standard Life",
  "SMART",
  "Aviva",
  "Royal London",
  "Scottish Widows"
]

const validateStep = () => {

  error.value = [];


  if (props.formData.pensionProviderName === undefined) {
    error.value.push('A Pension Provider Name must be provided.');
  }

  if (
    props.formData.pensionProviderName.length > 40
  ) {
    error.value.push('Pension Provider Name cannot be longer than 40 characters.');
  }

  if (
    !/^[A-Za-z0-9' ]+$/.test(props.formData.pensionProviderName)
  ) {
    error.value.push('Pension Provider Name must be provided as letters, numbers, or spaces only.');
  }


  if (error.value.length > 0) return false;


  return true;
}



const executeStep = async () => {
  return true;
}



onMounted(() => {

});

defineExpose({ validateStep, executeStep });

</script>